import React from "react";
import { mapTableRows } from "../../../../utils";
import { StatusTags, TableAdv } from "../../../../components";
import { Link } from "react-router-dom";
import { getItem } from "../../../../utils/localStorageUtils";

const MyTickets = () => {
  const portal = getItem("portal");

  // Detect base route (ats or bs)
  const columns = [
    {
      key: "ticketId",
      label: "Ticket ID",
      render: (row) => (
        // <Link to={"/ats/help/ticket-details"} className="text-info">
        <Link to={`/${portal}/help/ticket-details`} className="text-info">
          {row.ticketId}
        </Link>
      ),
    },
    {
      key: "ticketTitle",
      label: "Ticket Title",
    },
    {
      key: "status",
      label: "Status",
    },
    {
      key: "priority",
      label: "Priority",
      render: (row) => (
        <StatusTags
          tag={row.priority}
          className="!bg-danger-100 !text-danger-500"
        />
      ),
    },
    {
      key: "ticketType",
      label: "Ticket Type",
    },
    {
      key: "resolutionDue",
      label: "Resolution Due",
    },
    {
      key: "reportedOn",
      label: "Reported On",
    },
    {
      key: "modifiedOn",
      label: "Modified On",
    },
  ];
  const rows = [
    {
      ticketId: 13623,
      ticketTitle: "VMS Issue",
      status: "Resolved",
      priority: "High",
      ticketType: "Ticket",
      resolutionDue: "Mar 25, 2025",
      reportedOn: "Mar 21, 2025",
      modifiedOn: "Mar 23, 2025",
    },
    {
      ticketId: 84526,
      ticketTitle: "Account Login Failed",
      status: "Resolved",
      priority: "Medium",
      ticketType: "Ticket",
      resolutionDue: "Mar 25, 2025",
      reportedOn: "Mar 21, 2025",
      modifiedOn: "Mar 23, 2025",
    },
    {
      ticketId: 78331,
      ticketTitle: "Cancel Request",
      status: "Closed",
      priority: "Low",
      ticketType: "Ticket",
      resolutionDue: "Mar 25, 2025",
      reportedOn: "Mar 21, 2025",
      modifiedOn: "Mar 23, 2025",
    },
    {
      ticketId: 90365,
      ticketTitle: "Tektree Login",
      status: "Resolved",
      priority: "Low",
      ticketType: "Ticket",
      resolutionDue: "Mar 25, 2025",
      reportedOn: "Mar 21, 2025",
      modifiedOn: "Mar 23, 2025",
    },
    {
      ticketId: 32575,
      ticketTitle: "Account Login Failed",
      status: "Closed",
      priority: "Low",
      ticketType: "Ticket",
      resolutionDue: "Mar 25, 2025",
      reportedOn: "Mar 21, 2025",
      modifiedOn: "Mar 23, 2025",
    },
    {
      ticketId: 23942,
      ticketTitle: "Account Login Failed",
      status: "Closed",
      priority: "Low",
      ticketType: "Ticket",
      resolutionDue: "Mar 25, 2025",
      reportedOn: "Mar 21, 2025",
      modifiedOn: "Mar 23, 2025",
    },
  ];
  const mappedRows = mapTableRows(rows, columns);

  return (
    <div className="flex-1 overflow-auto">
      <TableAdv
        rows={mappedRows}
        columns={columns}
        toolbarRight={{ fullScreen: true }}
        tableId={"help_mytickets"}
      />
    </div>
  );
};

export default MyTickets;
